import { useContext } from "react";
import {
    FormatReportValueOptions,
    formatReportValueResult,
} from "@common/helpers/reports";
import { AccountingReportContext } from "./AccountingReport.context";
import styles from "./reportAmount.module.scss";

export function useReportAmountDisplay(
    value: number,
    options?: Omit<FormatReportValueOptions, "numberFormat">,
): { text: string; negativeClassName?: string } {
    const { numberFormat } = useContext(AccountingReportContext);
    const amount = formatReportValueResult(value, {
        ...options,
        numberFormat,
    });
    const isNegativeInRed = Boolean(
        numberFormat?.isNegativeInRed && amount.isNegative,
    );

    return {
        text: amount.text,
        negativeClassName: isNegativeInRed ? styles.negative : undefined,
    };
}
